interface IPostSocialLinks {
    facebook: string
    twitter: string
}

class PostSocialLinks implements IPostSocialLinks {
    facebook = ''
    twitter = ''

    constructor (dto?: IPostSocialLinks) {
        if (dto) {
            this.facebook = dto.facebook
            this.twitter = dto.twitter
        }
    }
}

export {
    IPostSocialLinks, PostSocialLinks
}
